import React from 'react';
import type { FC } from 'react';

interface ResizeHandleProps {
    position: 'top' | 'bottom';
    visible: boolean;
    onMouseDown: (e: React.MouseEvent<HTMLDivElement>) => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    className?: string;
}

/**
 * ResizeHandle component for schedule cards
 * Provides visual handles for resizing schedule entries by dragging top or bottom edges
 */
const ResizeHandle: FC<ResizeHandleProps> = ({
    position,
    visible,
    onMouseDown,
    onMouseEnter,
    onMouseLeave,
    className = ''
}) => {
    if (!visible) return null;

    const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onMouseDown(e);
    };

    const baseClasses = `
        absolute left-0 right-0 z-20 
        bg-transparent hover:bg-blue-500/20 
        transition-all duration-150 ease-in-out
        cursor-ns-resize
        flex items-center justify-center
        opacity-0 hover:opacity-100
        group-hover:opacity-60 hover:!opacity-100
    `;

    const positionClasses = position === 'top'
        ? 'top-0 -mt-1 h-3'
        : 'bottom-0 -mb-1 h-3';

    return (
        <div
            className={`${baseClasses} ${positionClasses} ${className}`}
            onMouseDown={handleMouseDown}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            data-resize-handle={position}
        >
            {/* Visual indicator - only show on hover */}
            <div className="w-8 h-0.5 bg-blue-500 rounded-full opacity-0 hover:opacity-100 transition-opacity duration-150" />
        </div>
    );
};

export default ResizeHandle;